
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';


export default function TabBtn({ value, handleTabbtnChange }) {
  return (
    <Tabs value={value} onChange={handleTabbtnChange} aria-label="disabled tabs example" className='row'>
      <Tab label="All" value="all" className='col-md-2' />
      <Tab label="livebots" value="livebots" className='col-md-2' />
        {/* <Tab label="Recents" value ={"recents"} className='col-md-2' /> */}
      {/* <Tab label="Templates" value={"templates"}  className='col-md-2'/> */}
      {/* <Tab label="Active" value={"active"} className='col-md-2' /> */}
    </Tabs>
  );
}
